module.exports = __webpack_public_path__ + "media/assets/images/icon_linkin-6ca8a15edaf98c54b35aa73e3620a01f.png";